/**
 * This function calculate the width of a string based on its length
 * @param {String} text
 * @param {String} font
 */
const getTextWidth = (text, font = '14px -apple-system') => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    if (!context) {
        return 100
    }
    context.font = font
    const metrics = context.measureText(text)
    return Math.round(metrics.width + 80)
}

export function formatNumberWithGrouping(n: number): string {
    if (!Number.isFinite(n)) {
        return String(n);
    }
    const negative = n < 0;
    const abs = Math.abs(n);
    const [intPart, fracPart] = abs.toString().split('.');
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const result = fracPart ? `${intFormatted}.${fracPart}` : intFormatted;
    return negative ? `-${result}` : result;
}

/**
 * This function calculates the width of each column based in all CELL VALUES
 * @param {Array} columns
 * @param {Array} source
 * @param {number} maxWidthPerCell
 */

export const calculateColumnsWidth = (
    columns: any[],
    source: any[],
    maxWidthPerCell: number = 500
) => {
    const formattedSource = source.map(entry => ({ ...entry }));
    const columnsWithWidth = columns.map(column =>
        Object.assign({}, column, {
            width: getTextWidth(column.title)
        })
    );

    formattedSource.forEach((entry, _rowIndex) => {
        columnsWithWidth.forEach((column, indexColumn) => {
            const key = column.dataIndex;
            let cellValue = entry[key];

            let cellWidth = getTextWidth(cellValue);

            if (cellWidth < column.width) {
                cellWidth = column.width;
            }
            if (cellWidth > maxWidthPerCell) {
                cellWidth = maxWidthPerCell;
            }

            columnsWithWidth[indexColumn].width = Math.max(
                columnsWithWidth[indexColumn].width,
                cellWidth
            );
        });
    });

    const tableWidth = columnsWithWidth
        .map(column => column.width)
        .reduce((a, b) => a + b, 0);

    return {
        columns: columnsWithWidth,
        source: formattedSource,
        tableWidth
    };
};
